import { render } from "./ActiveOrderCard.vue?vue&type=template&id=867d1088"
import script from "./ActiveOrderCard.vue?vue&type=script&lang=js"
export * from "./ActiveOrderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__